export function phoneNumberFormatter(phoneNumber: string | string) {
  const cleanedString = ("" + phoneNumber).replace(/\D/g, "");
  const formattedPhoneNumber = cleanedString.replace(
    /^\s*(\d{2}|\d{3}|\d{0})[-. ]?(\d{5}|\d{4})[-. ]?(\d{4})[-. ]?\s*$/,
    "($1) $2-$3"
  );
  return formattedPhoneNumber;
}
